import { useAuth } from '../services/AuthService';
import { Container, CircularProgress, Alert, AlertTitle, Button } from '@mui/material';
import AuthenticationRequired from './AuthenticationRequired';
import { useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <Container sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
        <CircularProgress sx={{ color: 'primary.main' }} />
      </Container>
    );
  }

  if (!isAuthenticated) {
    const returnTo = `${location.pathname}${location.search || ''}`;
    return (
      <AuthenticationRequired 
        message="You need to be logged in to access this page. Join thousands of job seekers and employers on our platform!"
        returnTo={returnTo}
      />
    );
  }

  if (adminOnly) {
    const groups = user?.groups || [];
    if (!groups.includes('admin')) {
      return (
        <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
          <Alert severity="error" sx={{ mb: 3 }}>
            <AlertTitle>Access Denied</AlertTitle>
            You do not have permission to access the admin panel.
          </Alert>
          <Button variant="contained" href="/dashboard">
            Go to Dashboard
          </Button>
        </Container>
      );
    }
  }

  return children;
};

export default ProtectedRoute;